import { useState } from "react";
import { Icon, ModalWrapper, RenderWhen } from "../../../components";
import ParanoidMode from "../../paranoid-mode/ParanoidMode";
import useParanoidMode from "../../paranoid-mode/hooks/useParanoidMode";
import { riskToleranceLevelConfig } from "../../paranoid-mode/riskToleranceLevelConfig";
import styles from "./styles/risk-tolerance-level-indicator.module.scss";

const RiskToleranceLevelIndicator = () => {
  const [show, setShow] = useState(false);
  const { paranoidModeConfig, enabledComponents } = useParanoidMode();
  return (
    <RenderWhen condition={!!paranoidModeConfig?.level}>
      <span className={styles.indicator}>
        Risk Tolerance <br />
        <span className={styles.level}>
          {riskToleranceLevelConfig[paranoidModeConfig?.level ?? 0].id}
          <span
            className={styles.help_container}
            onClick={e => {
              e.stopPropagation();
              setShow(true);
            }}
          >
            <Icon
              className={styles.help_icon}
              name="help"
              data-testid="risk_tolerance_indicator_help"
            />
          </span>
        </span>
      </span>
      <ModalWrapper
        title="Risk Tolerance Levels"
        data-testid="risk-tolerance-levels-display"
        show={show}
        onHide={() => setShow(false)}
        size={"xxl" as never}
      >
        <ParanoidMode
          currentLevel={paranoidModeConfig?.level || 0}
          enabledComponents={enabledComponents}
        />
      </ModalWrapper>
    </RenderWhen>
  );
};

export default RiskToleranceLevelIndicator;
